// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"input_inputWrapper__2TDLv","icon":"input_icon__2-V8w","input":"input_input__2A2iN","iconIncluded":"input_iconIncluded__2k6GM"};